import type { AddZonesToSavedMapResult } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const createInterestZoneSavedMap = async (payload: {
  name: string
  description?: string | null
}) => {
  const { data } = await gozokiApiWithAuth.post('/interest-zone-saved-maps', payload)
  return data as { id: number; name: string; description: string | null }
}

export const updateInterestZoneSavedMap = async (
  id: number,
  payload: { name?: string; description?: string | null },
) => {
  const { data } = await gozokiApiWithAuth.patch(`/interest-zone-saved-maps/${id}`, payload)
  return data
}

export const deleteInterestZoneSavedMap = async (id: number) => {
  const { data } = await gozokiApiWithAuth.delete(`/interest-zone-saved-maps/${id}`)
  return data
}

export const addZonesToSavedMap = async (
  id: number,
  payload: { runKey: string; zoneIds: number[] },
): Promise<AddZonesToSavedMapResult> => {
  const { data } = await gozokiApiWithAuth.post<AddZonesToSavedMapResult>(
    `/interest-zone-saved-maps/${id}/zones`,
    payload,
  )
  return data
}

export const removeZoneFromSavedMap = async (id: number, zoneId: number) => {
  const { data } = await gozokiApiWithAuth.delete(`/interest-zone-saved-maps/${id}/zones/${zoneId}`)
  return data
}
